module.exports = __webpack_public_path__ + "img/404-face.6dacc22c.svg";